<template>
  <div v-if="isMounted">
    <div class="vx-col w-full mb-3 bg-white">
      <vs-collapse type="border">
        <vs-collapse-item>
          <div slot="header">Filters</div>
          <form>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <component :is="fName[1].type" :structure="fName[1]" v-for="(fName) in showFormFields[0]"
                  :key="fName[0] + status" :index="fName[0]" :value="showValue(fName[0])" :appendToBody="true"
                  @input="(data) => inputParams[data.index] = data.value"></component>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <component :is="fName[1].type" :structure="fName[1]" v-for="(fName) in showFormFields[1]"
                  :key="fName[0] + status" :index="fName[0]" :value="showValue(fName[0])"
                  @input="(data) => inputParams[data.index] = data.value"></component>
              </div>
            </div>
            <div class="flex flex-wrap items-center" slot="footer">
              <vs-button class="mr-6" @click="filterNow()">Filter Now</vs-button>
              <vs-button type="border" color="warning" @click="reset()">Reset</vs-button>
            </div>
          </form>
        </vs-collapse-item>
      </vs-collapse>
    </div>
  </div>
</template>

<script>
import axios from "@/axios.js";
import { mapGetters } from "vuex";

import { settingsMixin } from "./settingsMixin";

import aronTextbox from "../../components/aron/formElements/textbox";
import aronInteger from "../../components/aron/formElements/integer";
import aronPassword from "../../components/aron/formElements/password";
import aronSelect from "../../components/aron/formElements/select.vue";
import aronMultiSelect from "../../components/aron/formElements/multiselect";
import aronRadio from "../../components/aron/formElements/radio";
import aronRadioStatic from "../../components/aron/formElements/radioStatic";
import aronTextarea from "../../components/aron/formElements/textArea";
import aronCurrency from "../../components/aron/formElements/currency";
import aronNumber from "../../components/aron/formElements/number";
import aronDate from "../../components/aron/formElements/date";
import aronYearOnly from "../../components/aron/formElements/yearOnly";
import aronFile from "../../components/aron/formElements/file";
export default {
  mixins: [settingsMixin],

  components: {
    aronTextbox,
    aronPassword,
    aronSelect,
    aronMultiSelect,
    aronRadio,
    aronRadioStatic,
    aronTextarea,
    aronCurrency,
    aronNumber,
    aronDate,
    aronYearOnly,
    aronFile,
    aronInteger
  },

  data() {
    return {
      status: "normal",
      baseUrl: axios.defaults.baseURL,
      isMounted: false,
      currentView: "list",
      inputParams: {},
      errorParams: [],
      data: {}
    };
  },

  computed: {
    ...mapGetters({
      getUserInfo: "auth/getUserInfo",
      getOrigCurrentDataStructure: "profile/getOrigCurrentDataStructure",
      getOrigDataStructure: "profile/getOrigDataStructure"
    }),
    settings() {
      return this.getSearch(this.$route.params.subject, this.$route.params.key);
    },
    mainSettings() {
      return this.getSettings(
        this.$route.params.subject,
        this.$route.params.key
      );
    },
    showFormFields() {
      try {
        console.log(
          "childDataMarker:",
          this.$store.state.profile.childDataMarker
        );

        var dataFilter = _.pickBy(this.getOrigDataStructure, function (st) {
          if (st.hasOwnProperty("showAsFilter")) {
            return st.showAsFilter.toLowerCase() == "yes";
          }
        });

        if (this.$store.state.profile.childDataMarker == "child") {
          console.log("current struc:", this.getOrigCurrentDataStructure);

          dataFilter = _.pickBy(this.getOrigCurrentDataStructure, function (st) {
            if (st.hasOwnProperty("showAsFilter")) {
              return st.showAsFilter.toLowerCase() == "yes";
            }
          });
        }

        console.log("dataFilter:", dataFilter);

        var objCount = Math.ceil(Object.entries(dataFilter).length / 2);
        console.log("objCount:", objCount);
        const arrayFromObject = Object.entries(dataFilter);
        return _.chunk(arrayFromObject, objCount);
      } catch (exception) {
        console.error(exception);
      }
    }
  },

  // 1. fil
  created() {
    console.log("search:", this.settings);
    console.log("showFormFields:", this.showFormFields);
    console.log("mainSettings:", this.mainSettings);
  },

  mounted() {
    if (this.showFormFields.length > 0) {
      this.isMounted = true;
    } else {
      this.isMounted = false;
    }
  },

  methods: {
    filterNow() {
      console.log("this.inputParams:", this.inputParams);
      this.$emit("submit", this.inputParams);
      this.status = "submit";
    },
    reset() {
      this.$emit("submit", {});
      this.inputParams = {};
      this.status = "reset";
    },
    showValue(colName) {
      return this.inputParams[colName];
    },
    collapse(event) {
      console.log("eventsss:", event);
    }
  }
};
</script>

